<template>
  <v-card class="trezo-card bg-white border-0 shadow-none border-radius mb-0">
    <div class="v-card-header">
      <h5 class="mb-0">Son Aktiviteler</h5>
    </div>

    <div class="d-flex align-center px-4">
      <v-tabs v-model="tab" color="#1a5f4a" class="flex-grow-1">
        <v-tab value="questions">Son Sorular</v-tab>
        <v-tab value="low_rated">
          Düşük Puanlılar
          <v-chip v-if="lowRated.length" size="x-small" color="error" class="ml-1">
            {{ lowRated.length }}
          </v-chip>
        </v-tab>
        <v-tab value="comments">Yorumlar</v-tab>
      </v-tabs>

      <v-btn
        variant="tonal"
        color="#1a5f4a"
        size="small"
        :disabled="!activeTabRows.length"
        @click="exportActiveTab"
      >
        <span class="material-symbols-outlined mr-1" style="font-size:16px">download</span>
        XLS İndir
      </v-btn>
    </div>

    <v-divider />

    <v-tabs-window v-model="tab">
      <!-- Son Sorular -->
      <v-tabs-window-item value="questions">
        <div v-if="!recentQuestions.length" class="text-center text-muted py-6">
          Henüz soru yok
        </div>
        <v-data-table
          v-else
          :headers="questionHeaders"
          :items="recentQuestions"
          density="compact"
          :items-per-page="25"
          :items-per-page-options="[25, 50, 100, 200]"
          @click:row="(_: Event, row: { item: RecentQuestion }) => openDetail(row.item)"
          style="cursor:pointer"
        >
          <template #item.user_name="{ item }">
            <span class="font-weight-medium">{{ item.user_name }}</span>
            <span v-if="item.username" class="text-caption text-medium-emphasis ml-1">
              ({{ item.username }})
            </span>
          </template>

          <template #item.question="{ item }">
            <span class="question-cell">{{ item.question }}</span>
          </template>

          <template #item.asked_at="{ item }">
            <span class="text-caption text-medium-emphasis">
              {{ formatDate(item.asked_at) }}
            </span>
          </template>

          <template #item.rating="{ item }">
            <span v-if="item.rating" class="d-flex align-center">
              <span
                v-for="i in 5" :key="i"
                class="material-symbols-outlined"
                :style="{ fontSize: '16px', color: i <= item.rating ? '#c9a227' : '#ddd' }"
              >star</span>
            </span>
            <span v-else class="text-medium-emphasis text-caption">—</span>
          </template>
        </v-data-table>
      </v-tabs-window-item>

      <!-- Düşük Puanlılar -->
      <v-tabs-window-item value="low_rated">
        <div v-if="!lowRated.length" class="text-center text-muted py-6">
          Düşük puanlı cevap yok
        </div>
        <v-data-table
          v-else
          :headers="lowRatedHeaders"
          :items="lowRated"
          density="compact"
          :items-per-page="25"
          :items-per-page-options="[25, 50, 100, 200]"
          @click:row="(_: Event, row: { item: LowRatedQuestion }) => openDetail(row.item)"
          style="cursor:pointer"
        >
          <template #item.user_name="{ item }">
            <span class="font-weight-medium">{{ item.user_name }}</span>
          </template>

          <template #item.question="{ item }">
            <v-tooltip v-if="item.question" location="top" max-width="400">
              <template #activator="{ props: tp }">
                <span v-bind="tp" class="question-cell">{{ item.question }}</span>
              </template>
              {{ item.question }}
            </v-tooltip>
            <span v-else class="text-medium-emphasis text-caption">—</span>
          </template>

          <template #item.rating="{ item }">
            <span class="d-flex align-center">
              <span
                v-for="i in 5" :key="i"
                class="material-symbols-outlined"
                :style="{ fontSize: '16px', color: i <= item.rating ? '#c9a227' : '#ddd' }"
              >star</span>
            </span>
          </template>

          <template #item.comment="{ item }">
            <span v-if="item.comment" class="text-caption">{{ item.comment }}</span>
            <span v-else class="text-medium-emphasis text-caption">—</span>
          </template>

          <template #item.asked_at="{ item }">
            <span class="text-caption text-medium-emphasis">
              {{ formatDate(item.asked_at) }}
            </span>
          </template>
        </v-data-table>
      </v-tabs-window-item>

      <!-- Yorumlar -->
      <v-tabs-window-item value="comments">
        <div v-if="!recentComments.length" class="text-center text-muted py-6">
          Henüz yorum yok
        </div>
        <v-data-table
          v-else
          :headers="commentHeaders"
          :items="recentComments"
          density="compact"
          :items-per-page="25"
          :items-per-page-options="[25, 50, 100, 200]"
        >
          <template #item.user_name="{ item }">
            <span class="font-weight-medium">{{ item.user_name }}</span>
          </template>

          <template #item.question="{ item }">
            <v-tooltip v-if="item.question" location="top" max-width="400">
              <template #activator="{ props: tp }">
                <span v-bind="tp" class="question-cell">{{ item.question }}</span>
              </template>
              {{ item.question }}
            </v-tooltip>
            <span v-else class="text-medium-emphasis text-caption">—</span>
          </template>

          <template #item.comment="{ item }">
            <span class="text-caption">{{ item.comment }}</span>
          </template>

          <template #item.rating="{ item }">
            <span v-if="item.rating" class="d-flex align-center">
              <span
                v-for="i in 5" :key="i"
                class="material-symbols-outlined"
                :style="{ fontSize: '16px', color: i <= item.rating ? '#c9a227' : '#ddd' }"
              >star</span>
            </span>
            <span v-else class="text-medium-emphasis text-caption">—</span>
          </template>

          <template #item.commented_at="{ item }">
            <span class="text-caption text-medium-emphasis">
              {{ formatDate(item.commented_at) }}
            </span>
          </template>
        </v-data-table>
      </v-tabs-window-item>
    </v-tabs-window>

    <!-- Soru/Cevap Dialog -->
    <v-dialog v-model="dialog" max-width="800" scrollable>
      <v-card v-if="selected">
        <v-card-title class="d-flex align-center pa-4 pb-2">
          <span class="material-symbols-outlined mr-2" style="color:#1a5f4a">forum</span>
          <span class="text-body-1 font-weight-medium">Soru & Cevap Detayı</span>
          <v-spacer />
          <v-btn
            v-if="selected?.conversation_id"
            variant="tonal"
            color="#1a5f4a"
            size="small"
            class="mr-2"
            @click="openFullPage"
          >
            <span class="material-symbols-outlined mr-1" style="font-size:16px">open_in_full</span>
            Tam sayfaya geç
          </v-btn>
          <v-btn icon variant="text" @click="dialog = false">
            <span class="material-symbols-outlined">close</span>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-4" style="max-height:70vh; overflow-y:auto">
          <!-- Meta -->
          <div class="d-flex align-center mb-3 text-caption text-medium-emphasis">
            <span class="material-symbols-outlined mr-1" style="font-size:16px">person</span>
            <span
              class="font-weight-medium mr-1 user-link"
              @click="goToUser(selected.username)"
            >{{ selected.user_name }}</span>
            <span v-if="selected.username" class="user-link" @click="goToUser(selected.username)">({{ selected.username }})</span>
            <v-spacer />
            <span>{{ formatDate(selected.asked_at) }}</span>
            <template v-if="selected.rating">
              <span class="mx-2">·</span>
              <span
                v-for="i in 5" :key="i"
                class="material-symbols-outlined"
                :style="{ fontSize: '15px', color: i <= selected.rating ? '#c9a227' : '#ddd' }"
              >star</span>
            </template>
          </div>

          <!-- Soru -->
          <v-sheet color="#f5f7f6" rounded class="pa-3 mb-4">
            <div class="text-caption text-medium-emphasis mb-1 d-flex align-center">
              <span class="material-symbols-outlined mr-1" style="font-size:15px">help</span>
              SORU
            </div>
            <p class="text-body-2 mb-0" style="white-space:pre-wrap">
              {{ selected.question_full || selected.question }}
            </p>
          </v-sheet>

          <!-- Cevap -->
          <v-sheet color="#f0f7f4" rounded class="pa-3">
            <div class="text-caption text-medium-emphasis mb-2 d-flex align-center">
              <span class="material-symbols-outlined mr-1" style="font-size:15px">smart_toy</span>
              MAHAI CEVABI
            </div>
            <div
              v-if="selected.answer"
              class="text-body-2 answer-content"
              v-html="renderMarkdown(selected.answer)"
            />
            <span v-else class="text-medium-emphasis text-caption">Cevap bulunamadı.</span>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { marked } from 'marked'
import { useRouter } from 'vue-router'
import { downloadXlsx } from '@/utils/exportXlsx'
import type { RecentQuestion, LowRatedQuestion, RecentComment } from '@/services/adminStatsApi'

const props = defineProps<{
  recentQuestions: RecentQuestion[]
  lowRated: LowRatedQuestion[]
  recentComments: RecentComment[]
}>()

const tab = ref('questions')
const router = useRouter()

const dialog = ref(false)
const selected = ref<RecentQuestion | LowRatedQuestion | null>(null)

function openDetail(item: RecentQuestion | LowRatedQuestion) {
  selected.value = item
  dialog.value = true
}

function openFullPage() {
  if (!selected.value?.conversation_id) return
  dialog.value = false
  router.push({ path: '/apps/decisions-ai', query: { conversation_id: String(selected.value.conversation_id) } })
}

function goToUser(username: string | null) {
  if (!username) return
  dialog.value = false
  router.push({ path: `/admin/users/${username}/questions` })
}

function renderMarkdown(text: string): string {
  return marked.parse(text) as string
}

function formatDate(dt: string): string {
  if (!dt) return '—'
  return new Date(dt).toLocaleString('tr-TR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

const questionHeaders = [
  { title: 'Kullanıcı', key: 'user_name', width: '180px' },
  { title: 'Soru', key: 'question' },
  { title: 'Tarih', key: 'asked_at', width: '140px' },
  { title: 'Puan', key: 'rating', width: '120px', sortable: false },
]

const lowRatedHeaders = [
  { title: 'Kullanıcı', key: 'user_name', width: '160px' },
  { title: 'Soru', key: 'question' },
  { title: 'Puan', key: 'rating', width: '120px', sortable: false },
  { title: 'Yorum', key: 'comment', width: '200px' },
  { title: 'Tarih', key: 'asked_at', width: '140px' },
]

const commentHeaders = [
  { title: 'Kullanıcı', key: 'user_name', width: '160px' },
  { title: 'Soru', key: 'question', width: '200px' },
  { title: 'Yorum', key: 'comment' },
  { title: 'Puan', key: 'rating', width: '120px', sortable: false },
  { title: 'Tarih', key: 'commented_at', width: '140px' },
]

const tabConfig = {
  questions: {
    sheetName: 'Son Sorular',
    fileSlug: 'son-sorular',
    headers: questionHeaders,
    rows: () => props.recentQuestions.map((q) => ({
      user_name: q.username ? `${q.user_name} (${q.username})` : q.user_name,
      question: q.question_full ?? q.question,
      asked_at: formatDate(q.asked_at),
      rating: q.rating ?? '',
    })),
  },
  low_rated: {
    sheetName: 'Düşük Puanlılar',
    fileSlug: 'dusuk-puanlilar',
    headers: lowRatedHeaders,
    rows: () => props.lowRated.map((q) => ({
      user_name: q.user_name,
      question: q.question_full ?? q.question ?? '',
      rating: q.rating,
      comment: q.comment ?? '',
      asked_at: formatDate(q.asked_at),
    })),
  },
  comments: {
    sheetName: 'Yorumlar',
    fileSlug: 'yorumlar',
    headers: commentHeaders,
    rows: () => props.recentComments.map((c) => ({
      user_name: c.user_name,
      question: c.question ?? '',
      comment: c.comment,
      rating: c.rating ?? '',
      commented_at: formatDate(c.commented_at),
    })),
  },
} as const

const activeTabRows = computed(() => tabConfig[tab.value as keyof typeof tabConfig].rows())

function exportActiveTab() {
  const config = tabConfig[tab.value as keyof typeof tabConfig]
  const today = new Date().toISOString().slice(0, 10)
  downloadXlsx(`${config.fileSlug}_${today}.xlsx`, config.sheetName, config.headers, activeTabRows.value)
}

</script>

<style scoped>
.question-cell {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 400px;
}

.user-link {
  cursor: pointer;
  color: #1a5f4a;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.user-link:hover {
  color: #0d3d2e;
}

.question-clickable {
  cursor: pointer;
  color: #1a5f4a;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.question-clickable:hover {
  color: #0d3d2e;
}

.answer-content :deep(p)       { margin-bottom: 0.5rem }
.answer-content :deep(ul),
.answer-content :deep(ol)      { padding-left: 1.5rem; margin-bottom: 0.5rem }
.answer-content :deep(h1),
.answer-content :deep(h2),
.answer-content :deep(h3)      { font-size: 1rem; font-weight: 600; margin: 0.75rem 0 0.25rem }
.answer-content :deep(strong)  { font-weight: 600 }
.answer-content :deep(code)    { background: rgba(0,0,0,0.06); padding: 0.1em 0.3em; border-radius: 3px; font-size: 0.85em }
</style>
